import { ComponentProps } from 'react';
import { Menu } from 'antd';
import clsx from 'clsx';

export const OpMenu = ({
  className,
  ...menuProps
}: ComponentProps<typeof Menu>) => {
  return <Menu className={clsx('op-menu', className)}
    {...menuProps} />;
};
